const setCart = function (state, data) {
    state.data = data
}

const setWishlist = function (state, data) {
    state.wishlist = data
}

const setLastItem = function (state, item) {
    const items = [...state.data.items].sort((a, b) =>
        Date.parse(a.updatedAt) > Date.parse(b.updatedAt) ? -1 : 1
    )
    let [lastItem] = items.filter((itemData) => itemData.productId === item.productId)

    lastItem = Object.assign({}, lastItem)
    lastItem.qty = item.qty
    lastItem.originalSubtotal = lastItem.originalPrice * item.qty
    lastItem.saleSubtotal = lastItem.salePrice * item.qty

    state.popupCart.lastItem = lastItem
    this.$uiEvents.$emit('addToCart', lastItem)
}

const setThirdParty = function (state, data) {
    state.thirdParty = data
}

export default {
    setCart,
    setLastItem,
    setThirdParty,
    setWishlist,
}
/*
let cartTimer = null

const getCart = (state) => {
    window.cartApi
        .getCart()
        .then((data) => {
            state.data = data
        })
        .catch((err) => console.err(err))
}


const popupVisible = (state, bool) => {
    const status = typeof bool === 'boolean' ? bool : !state.popupOptions.visible
    state.popupOptions.visible = status
}

const addItem = (state, itemInfo) => {
    // If no itemInfo is passed then exit the function
    if (!itemInfo) return

    const productInfo = Object.assign({}, itemInfo || {})

    // productInfo.productId = '109390'
    // productInfo.qty = 2
    // productInfo.fitmentData = {
    //   makeName: 'Ford',
    //   modelName: 'F-150',
    //   year: '2016',
    //   bedName: '6.5',
    //   bodyName: 'Crew Cab',
    //   engineName: '5.7 L',
    //   notes: 'Other info about the product that is not covered above',
    // }
    // productInfo.meta = {
    //   notes: 'Third party string data',
    // }

    state.popupOptions.lastItem = productInfo

    window.cartApi
        .addItems(productInfo)
        .then((data) => {
            state.data = data
        })
        .then(() => {
            if (state.isMobile) {
                state.popupOptions.visible = true
            } else {
                state.minicartOptions.fixed = true
                state.minicartOptions.visible = true
            }
        })
        .catch((err) => console.err(err))
}


} */
